import { Checkbox } from 'semantic-ui-react'

interface Props {
  content: boolean
}

export function Bool({ content }: Props) {
  return <Checkbox disabled checked={content} />
}
